<template>
<div>
      <div id="header">
        <b-navbar toggleable="md" type="" variant="light">
          <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
          <b-navbar-brand><router-link to="/home"><img src="/static/pawnee_logo.png" width="70%"/></router-link></b-navbar-brand>
            <b-collapse is-nav id="nav_collapse">
              <b-navbar-nav>
                <b-nav-item><router-link to="/home">Home</router-link></b-nav-item>
                <b-nav-item-dropdown text="Reports" style="display:none;">
                  <b-dropdown-item><router-link to="/home">End of Year Statements</router-link></b-dropdown-item>
                  <b-dropdown-item><router-link to="/home">EFA Amortization Statements</router-link></b-dropdown-item>
                  <b-dropdown-item><router-link to="/home">Another report</router-link></b-dropdown-item>
                </b-nav-item-dropdown>
                <b-nav-item><router-link to="/contracts">Contracts</router-link></b-nav-item>
                <b-nav-item><router-link to="/contact">Contact Us</router-link></b-nav-item>
                <b-nav-item><router-link to="/contactform">Email Support</router-link></b-nav-item>
              </b-navbar-nav>
              <b-navbar-nav class="ml-auto">
                <b-nav-text>Toll-Free Phone #: 1(800) 864-4266</b-nav-text>
                <b-nav-item-dropdown right>
                  <template slot="button-content">
                    <em v-if="user.authenticated">Hi, {{getName()}}!</em>
                    <em v-else><router-link to="/login">Login</router-link></em>
                  </template>
                <b-dropdown-item v-if="user.authenticated" @click="logout()">Logout</b-dropdown-item>
                <b-dropdown-item v-if="user.authenticated"><router-link to="/changepassword">Change Password</router-link></b-dropdown-item>
                </b-nav-item-dropdown>
              </b-navbar-nav>
            </b-collapse>
        </b-navbar>
      </div>
      <b-row>
          <b-col>

          </b-col>
        </b-row>
      <div class="container">
      <router-view></router-view>
      </div>

      <div id="footer">
        <div class="footer-copyright text-center py-3">
          &copy; Copyright 2018 <a href="http://www.pawneeleasing.com"> Pawnee Leasing Corporation</a> | Your A, B, C & Start-Up Credit Funding Source Since 1982
        </div>

    </div>
</div>
</template>

<script>
/* eslint-disable */
import auth from './auth'
import axios from 'axios'
import modalPrivacyPolicy from './modalPrivacyPolicy'

export default {
  name: 'App',
  components: {
    'modalPrivacyPolicy': modalPrivacyPolicy
  },
  data () {
    return {
      user: auth.user,
      userEmail: '',
      name: auth.checkName,
      firstName: '',
      apiUrl: localStorage.getItem('apiURL'),
      request: null
    }
  },
  methods: {
    showModal () {
      this.$refs['modalPrivacyPolicy'].show()
    },
    logout () {
      auth.logout()
    },
    getName () {
      if (!this.request) {
        this.request = axios
          .get(this.apiUrl + auth.user.clientID + '/userdata', {
            headers: auth.getAuthHeader()
          })
          .then(response => {
            this.items = response.data
            this.firstName = this.items.firstName
            localStorage.setItem('firstName', this.items.firstName)
          })
          .catch(error => {
            this.errored = true
          })
      }
      return this.firstName
    }
  }
}
</script>

<style src="bootstrap/dist/css/bootstrap.css"></style>
<style src="bootstrap-vue/dist/bootstrap-vue.css"></style>
<style>
html {
  box-sizing: border-box;
}
*, *:before, *:after {
  box-sizing: inherit;
}

.navbar-toggler-icon {
  background-image: url("data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='rgba(0,0,0, 0.95)' stroke-width='3' stroke-linecap='round' stroke-miterlimit='10' d='M4 8h24M4 16h24M4 24h24'/%3E%3C/svg%3E");
}
#header {
  background-color: #f8f9fa;
}
.container-fluid {
  height: 100vh;
}
.container {
    width: 100%;
    max-width: 100%;
}
.label{
  font-weight: bold;
}
body {
  font-size:16px;
}
h1 {
  font-size: 2rem;
}
h2 {
  font-size: 1.5rem;
}
h3 {
  font-size: 1.25rem;
}
h4, h5 {
  font-size: 1.15rem;
}
.btn {
  font-size: 0.9rem;
}
.modal-title{
      font-size:1.5em;
    }

@media only screen and (min-width: 980px) and (max-width: 1365px) {
  .btn {
    font-size: 0.7em;
  }
}
@media only screen and (min-width: 400px) and (max-width: 980px) {
  .btn {
    font-size: 0.7em;
  }
  .table.b-table {
    font-size: 0.8em;
  }
}

</style>



// WEBPACK FOOTER //
// src/App.vue